import { Box, Checkbox, FormGroup, Select, Text } from '@ksyos/design-system';
import { useEffect } from 'react';
import type { OsasTreatmentData } from '@common/validation/customControls/osas/osasTreatmentChoice/types';
import { TextAreaFormGroup } from '../../../../processActivityFormGroupFields';
import { weeksOptions } from '../weeksOptions';

type HasChosenTreatmentFieldsProps = {
    data: OsasTreatmentData;
    onChange: (data: Partial<OsasTreatmentData>, validateKeys?: string | string[] | undefined) => void;
};

export function HasChosenTreatmentFields(props: Readonly<HasChosenTreatmentFieldsProps>) {
    const defaultResendQuestionnairesWeeks = '2';
    const { data, onChange } = props;

    useEffect(() => {
        onChange({ resendQuestionnaires: !!data.resendQuestionnaires });
    }, []);

    return (
        <>
            <FormGroup label={'Herzend Ksyos vragenlijsten'}>
                <Box
                    alignItems="center"
                    display="flex"
                    flexDirection="row"
                    gap={2}
                    mt={1}
                    size="sm"
                >
                    <Checkbox
                        checked={!!data.resendQuestionnaires}
                        label={<Text whiteSpace="nowrap">Ja, na</Text>}
                        onChange={async (e) => {
                            onChange(
                                {
                                    resendQuestionnaires: e.target.checked,
                                    resendQuestionnairesWeeks: e.target.checked ? 2 : null,
                                },
                                ['resendQuestionnaires', 'resendQuestionnairesWeeks']
                            );
                        }}
                    />

                    <Box width={'80px'}>
                        <Select
                            onChange={async (option) => {
                                onChange(
                                    {
                                        resendQuestionnaires: true,
                                        resendQuestionnairesWeeks: parseInt(option?.value ?? '') ?? null,
                                    },
                                    ['resendQuestionnaires', 'resendQuestionnairesWeeks']
                                );
                            }}
                            options={weeksOptions}
                            value={{
                                label: data.resendQuestionnairesWeeks?.toString() ?? defaultResendQuestionnairesWeeks,
                                value: data.resendQuestionnairesWeeks?.toString() ?? defaultResendQuestionnairesWeeks,
                            }}
                        />
                    </Box>
                    <Text>weken</Text>
                </Box>
            </FormGroup>
            <TextAreaFormGroup
                fieldKey="adviceGeneralPractitionerForOsa"
                label="Advies aan de huisarts"
            />
        </>
    );
}
